import { MouseEvent as ReactMouseEvent, WheelEvent } from 'react';

export const getOffset = (
  evt: WheelEvent | MouseEvent | ReactMouseEvent | globalThis.WheelEvent
) => {
  let el = evt.target as HTMLElement,
    x = 0,
    y = 0;

  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    x += el.offsetLeft - el.scrollLeft;
    y += el.offsetTop - el.scrollTop;
    el = el.offsetParent as HTMLElement;
  }

  x = evt.clientX - x;
  y = evt.clientY - y;

  return { x, y };
};

export const onShiftClick =
  (func: () => void) => (e: MouseEvent | ReactMouseEvent) => {
    e.stopPropagation();

    if (e.shiftKey) {
      func();
    }
  };
